import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const generateHighchartStyles = ({ svgElementClassName }) => {
	const svgElementClassNameSelector = `.${svgElementClassName}`;

	return css`
		${svgElementClassNameSelector} {
			overflow: visible;
			font-family: Roboto;
		}

		${svgElementClassNameSelector} .highcharts-tick {
			display: none;
		}

		${svgElementClassNameSelector} .highcharts-plot-band {
			fill-opacity: 0;
		}

		${svgElementClassNameSelector} .highcharts-plot-band:hover {
			fill-opacity: 0.05;
		}

		${svgElementClassNameSelector} .highcharts-halo {
			fill-opacity: 0;
			stroke-opacity: 0;
		}

		${svgElementClassNameSelector} .highcharts-axis-labels {
			color: ${colors.grey7} !important;
			font-size: 11px !important;
			font-family: Roboto;
		}

		${svgElementClassNameSelector} .highcharts-axis-labels tspan {
			color: ${colors.grey7} !important;
			font-size: 11px !important;
			font-family: Roboto;
		}

		${svgElementClassNameSelector} .highcharts-crosshair-category {
			stroke: ${colors.grey7};
			stroke-opacity: 1;
		}

		${svgElementClassNameSelector} .highcharts-yaxis-grid .highcharts-grid-line {
			stroke-opacity: 0;
		}

		${svgElementClassNameSelector} .highcharts-data-label {
			font-size: 11px;
		}

		.highcharts-legend-item .highcharts-point {
			width: 16px;
			height: 16px;
			rx: 0;
			x: 0;
			y: 2;
		}

		.highcharts-legend {
			pointer-events: none;
		}

		${svgElementClassNameSelector} .highcharts-background {
			fill: rgba(0, 0, 0, 0) !important;
		}

		${svgElementClassNameSelector} .highchart-custom-tooltip {
			padding: 16px 16px 0;
			margin: 0;
			background-color: ${colors.white};
			border: 0px;
			box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
			position: relative;
		}

		${svgElementClassNameSelector} .highchart-custom-tooltip > li {
			margin-bottom: 8px;
			list-style: none;
		}

		.highchart-custom-tooltip > li:last-child {
			margin-bottom: 0;
		}

		${svgElementClassNameSelector} .highcharts-tooltip {
			fill-opacity: 0;
			background-color: transparent;
			stroke-opacity: 0;
		}

		${svgElementClassNameSelector} g.highcharts-tooltip {
			display: none;
		}

		${svgElementClassNameSelector} .highcharts-tooltip-box {
			fill: ${colors.white};
		}

		${svgElementClassNameSelector} .highcharts-column-series rect.highcharts-point {
			stroke: none;
		}
	`;
};

export const Wrapper = styled.div`
	z-index: 1;
	position: relative;

	display: flex;
	flex-direction: column;
	margin-top: 23px;
	margin-right: -10px;
	padding-left: 3px;

	& > div:first-child {
		top: 20px;
	}

	${generateHighchartStyles};
`;

export const ChartWrapper = styled.div`
	margin-top: 46px;

	.highcharts-label {
		transition: opacity 0.5s ease-in;
	}

	.highcharts-container-loading .highcharts-label {
		opacity: 0 !important;
		transition: none;
	}
`;

export const UnitsLabelBlock = styled.div`
	position: absolute;
	top: 0;
	margin-left: 8px;
	font-size: 11px;
	color: ${colors.grey6};
	margin-bottom: 12px;
	width: 36px;
	text-align: right;
`;

export const HighlightBlock = styled.div`
	opacity: 0;
	cursor: pointer;
	box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);

	position: absolute;
	z-index: 1;
	top: 0;
	bottom: 0;

	${({ width, left }) =>
		css`
			width: ${width}px;
			left: ${left}px;
		`};

	${({ isActive }) =>
		isActive &&
		css`
			opacity: 1;
		`};

	& > div:first-child {
		right: 0;
		top: 4px;
	}
`;

export const HighlightBlockWrapper = styled.div`
	position: absolute;

	${({ width, height, left }) =>
		css`
			width: ${width}px;
			height: ${height}px;
			left: ${left + 3}px;
		`};

	${({ isActive }) =>
		isActive &&
		css`
			${HighlightBlock}:hover {
				opacity: 1;
			}
		`};
`;

export const NoDataAvailableContainer = styled.div`
	font-weight: normal;
	color: #b7b7b7;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	position: absolute;
	bottom: 240px;
	right: 0;
	left: 0;
	z-index: 100;
`;

export const NoDataAvailableLabel = styled.span`
	font-size: 12px;

	@media (min-width: 800px) and (min-height: 500px) {
		font-size: 14px;
	}

	@media (min-width: 1100px) and (min-height: 700px) {
		font-size: 20px;
	}
`;

export const DetailsChartContainerWrapper = styled.div`
	position: relative;
`;

export const SummaryBackgroundWrapper = styled.div`
	position: absolute;
	height: ${props => props.height + 1 + 'px'};
	width: ${props => props.width + 'px'};
	background: ${colors.greyBg};
	border-bottom: 1px solid black;
	top: 20px;
`;

export const SummaryTriangle = styled.div`
	position: absolute;
	width: 0px;
	height: 0px;
	border-top: ${props => props.size + 'px solid transparent'};
	border-bottom: ${props => props.size + 'px solid transparent'};
	border-left: ${props => `${props.size}px solid ${colors.greyBg}`};
	top: ${props => props.top + 'px'};
	right: ${props => -props.size + 'px'};
`;
